module.exports = __webpack_public_path__ + "static/media/pie.4ddf11fe.svg";